import GoogleMapReact from "google-map-react";

function Map({
  center = {
    lat: 13.1057,
    lng: 109.295,
  },
  zoom = 14,
  children,
}) {
  return (
    <GoogleMapReact
      bootstrapURLKeys={{
        key: process.env.REACT_APP_GOOGLE_API,
        language: "en-US",
      }}
      defaultCenter={center}
      defaultZoom={zoom}
    >
      {children}
    </GoogleMapReact>
  );
}

export default Map;
